"use client";
import { HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import styles from "./Divider.module.css";

export interface DividerProps extends HTMLProps<HTMLElement> {}

export default function Divider({
	className
} : DividerProps) {
	return (
		<div
			className={cn(
				styles.Divider,
				className
			)}
		/>
	);
}